<template>
  <div class="softcity" style="background: #fcfcfc">
    <headbox></headbox>
    <div class="searchbox">
      <div class="searl">
        <div class="sertit">软件名城</div>
        <ul>
          <li>园区动态<span>></span></li>
          <li>企业动态<span>></span></li>
          <li id="serlistbox">人物榜样<span>></span></li>
          <li>产品服务<span>></span></li>
          <li>人才建设<span>></span></li>
          <li>科技创新<span>></span></li>
          <li>公共平台<span>></span></li>
        </ul>
      </div>
      <div class="seabl">
        <p class="dqwz">当前位置：<span>首页</span>>><span>软件名城</span>>><span>人物榜样</span></p>
        <div class="sercont">
          <ul>
            <li>
              <div class="stliimgbox">
                <img src="@/assets/images/Slice8.png" style="max-width: 206px; max-height: 131px" alt="" />
              </div>
              <div class="stlititbox">
                <h4>企业风采 | 积微物联再现“数实融合”成果 <span>2021-06-17</span></h4>
                <p>1月，由积微物联与宝信软件、攀钢国贸等共同打造的智慧营销平台“攀钢数智化营销项目”成功切换上线。该项</p>
                <span>【查看详情】</span>
              </div>
            </li>
            <li>
              <div class="stliimgbox">
                <img src="@/assets/images/Slice8.png" style="max-width: 206px; max-height: 131px" alt="" />
              </div>
              <div class="stlititbox">
                <h4>企业风采 | 积微物联再现“数实融合”成果 <span>2021-06-17</span></h4>
                <p>1月，由积微物联与宝信软件、攀钢国贸等共同打造的智慧营销平台“攀钢数智化营销项目”成功切换上线。该项</p>
                <span>【查看详情】</span>
              </div>
            </li>
            <li>
              <div class="stliimgbox">
                <img src="@/assets/images/Slice8.png" style="max-width: 206px; max-height: 131px" alt="" />
              </div>
              <div class="stlititbox">
                <h4>企业风采 | 积微物联再现“数实融合”成果 <span>2021-06-17</span></h4>
                <p>1月，由积微物联与宝信软件、攀钢国贸等共同打造的智慧营销平台“攀钢数智化营销项目”成功切换上线。该项</p>
                <span>【查看详情】</span>
              </div>
            </li>
            <li>
              <div class="stliimgbox">
                <img src="@/assets/images/Slice8.png" style="max-width: 206px; max-height: 131px" alt="" />
              </div>
              <div class="stlititbox">
                <h4>企业风采 | 积微物联再现“数实融合”成果 <span>2021-06-17</span></h4>
                <p>1月，由积微物联与宝信软件、攀钢国贸等共同打造的智慧营销平台“攀钢数智化营销项目”成功切换上线。该项</p>
                <span>【查看详情】</span>
              </div>
            </li>
            <li>
              <div class="stliimgbox">
                <img src="@/assets/images/Slice8.png" style="max-width: 206px; max-height: 131px" alt="" />
              </div>
              <div class="stlititbox">
                <h4>企业风采 | 积微物联再现“数实融合”成果 <span>2021-06-17</span></h4>
                <p>1月，由积微物联与宝信软件、攀钢国贸等共同打造的智慧营销平台“攀钢数智化营销项目”成功切换上线。该项</p>
                <span>【查看详情】</span>
              </div>
            </li>
            <li>
              <div class="stliimgbox">
                <img src="@/assets/images/Slice8.png" style="max-width: 206px; max-height: 131px" alt="" />
              </div>
              <div class="stlititbox">
                <h4>企业风采 | 积微物联再现“数实融合”成果 <span>2021-06-17</span></h4>
                <p>1月，由积微物联与宝信软件、攀钢国贸等共同打造的智慧营销平台“攀钢数智化营销项目”成功切换上线。该项</p>
                <span>【查看详情】</span>
              </div>
            </li>
            <li>
              <div class="stliimgbox">
                <img src="@/assets/images/Slice8.png" style="max-width: 206px; max-height: 131px" alt="" />
              </div>
              <div class="stlititbox">
                <h4>企业风采 | 积微物联再现“数实融合”成果 <span>2021-06-17</span></h4>
                <p>1月，由积微物联与宝信软件、攀钢国贸等共同打造的智慧营销平台“攀钢数智化营销项目”成功切换上线。该项</p>
                <span>【查看详情】</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <footbox></footbox>
  </div>
</template>
<script>
import headbox from "../components/head.vue";
import footbox from "@/components/footer.vue";
export default {
  name: "softcity",
  //声明传递过来的子组件
  components: {
    headbox,
    footbox,
  },
};
</script>
<style lang="less" scoped>
.searchbox {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  text-align: left;
  margin-top: 20px;
}
.searl {
  flex: 2;
   @media screen and (max-width:800px) {
    display: none;
  }
}
.seabl {
  flex: 8;
  min-height: 1200px;
}
.sertit {
  width: 100%;
  height: 46px;
  line-height: 46px;
  background: #ff9900;
  color: #fff;
  font-size: 24px;
  padding-left: 15px;
}
.searl > ul {
  margin-top: 11px;
  border: 1px solid #e4e4e4;
}
.searl > ul > li {
  height: 39px;
  padding-left: 15px;
  border-bottom: 1px solid #e4e4e4;
  line-height: 39px;
  font-size: 16px;
  color: #7a7a7a;
}
.searl > ul > li > span {
  float: right;
  color: #e4e4e4;
}
#serlistbox {
  background: #42a5f6;
  color: #fff;
}
.dqwz {
  margin-left: 64px;
}
.sercont {
  margin: 30px 33px 0 110px;
}
.sercont > ul li {
  display: flex;
}
.stliimgbox {
  flex: 2;
}
.stlititbox {
  flex: 8;
  height: 130px;
  margin: 24px 46px 0 33px;
}
.stlititbox > h4 {
  font-size: 18px;
  color: #525252;
}
.stlititbox > h4 > span {
  float: right;
  color: #b1b1b1;
  font-size: 16px;
}
.stlititbox > p {
  margin-top: 13px;
  font-size: 16px;
  color: #7a7a7a;
}
.stlititbox > span {
  float: right;
  color: #b1b1b1;
}
@media screen and (max-width: 1100px) {
  .stlititbox > h4 > span {
    display: none;
  }
}
@media screen and (max-width: 900px) {
  .searchbox {
    display: block;
  }
  .stlititbox > h4 > span {
    display: block;
  }
  .dqwz{
    margin-left: 15px;
  }
  .sercont {
    margin: 10px;
  }
}
</style>
